import Layout from '@/container/Full'
const ApplicationsList = () => import(/* webpackChunkName: "applications" */ '../views/applications/ApplicationsList.vue')
const ApplicationsDeploy = () => import(/* webpackChunkName: "applications" */ '../views/applications/ApplicationsDeploy.vue')
const ApplicationsApp = () => import(/* webpackChunkName: "applications" */ '../views/applications/ApplicationsApp.vue')

// Applications: the Docker apps on all of a customer's Docker-host servers in one
// place. The server is `serviceId`, NOT `hostingid` — router/index.js runs a
// billing lookup for any non-/servers route with a `hostingid` param.
const routes = [
  {
    path: '/applications',
    component: Layout,
    children: [
      {
        path: '',
        name: 'applications',
        component: ApplicationsList,
        meta: {
          breadcrumb: 'Applications',
          pageTitle: 'Applications',
          access_type: 'authorized',
        },
      },
      {
        // ?server=<id> preselects the server ("Deploy app here").
        path: 'deploy',
        name: 'applications_deploy',
        component: ApplicationsDeploy,
        meta: {
          breadcrumb: 'Deploy an app',
          pageTitle: 'Deploy an app',
          parent: 'applications',
          access_type: 'authorized',
        },
      },
      {
        path: ':serviceId/:app',
        name: 'applications_app',
        component: ApplicationsApp,
        props: true,
        meta: {
          breadcrumb: 'Manage app',
          pageTitle: 'Manage app',
          parent: 'applications',
          access_type: 'authorized',
        },
      },
    ],
  },
]

export default routes
